import React, { PropsWithChildren } from "react"
import { PropsWithTheme } from "../../library/Theme"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { SxProps, Theme } from "@mui/material"

interface SecondaryIconButtonProps {
  id?: string
  text: string
  onPress?: () => void
  sx?: SxProps<Theme>
}

export default function SecondaryIconButton({
  theme,
  id,
  text,
  children,
  onPress,
  sx: sxProp,
}: PropsWithChildren<PropsWithTheme<SecondaryIconButtonProps>>) {
  return (
    <Box
      id={id}
      onClick={onPress}
      sx={{
        cursor: "pointer",
        transition: "transform 0.2s",
        textAlign: "center",
        "&:hover": { transform: "scale(1.1)" },
        "& svg": { height: 36 },
        ...sxProp as object,
      }}
    >
      {children}
      <Typography
        sx={{
          mt: 1,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: 0,
          lineHeight: "14px",
          maxWidth: 62,
          ...theme.textStyle,
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}
